import { fetchProxy } from './api/api'
import environment from '../../environment'
import { toCatalogDetail, toDataDetail } from '../../links'
import {
  type DataIdentifier,
  type DataResult,
  DataSubtype,
  DataType,
  PageInfo,
} from '../../pages/SearchPage/types'
import { getScopes } from './auth/auth'
import AuthScope from './api/authScope'

export const MIN_QUERY_LENGTH = 3

const SEARCH_API_URL = `${environment.SEARCH_URL}api/search`
export const SEARCH_CATEGORIES_SUGGEST = {
  adressen: 4,
  straten: 3,
  openbareruimte: 2,
  openbareruimte_id: 2,
  adresseerbare_objecten: 2,
  nummeraanduidingen: 2,
  gebieden: 2,
  postcodes: 2,
  panden: 2,
  monumenten: 2,
  kadastrale_objecten: 2,
  kaartlagen: 2,
  catalogus: 2,
}

export const SEARCH_CATEGORIES_SUGGEST_AND_HR = {
  ...SEARCH_CATEGORIES_SUGGEST,
  vestigingen: 2,
  maatschappelijkeactiviteit: 2,
}

export const SEARCH_CATEGORIES_ALL_RESULTS = {
  straten: 6,
  openbareruimte: 6,
  openbareruimte_id: 6,
  adresseerbare_objecten: 6,
  nummeraanduidingen: 6,
  adressen: 6,
  gebieden: 6,
  postcodes: 6,
  panden: 6,
  monumenten: 6,
  kadastrale_objecten: 6,
  kaartlagen: 100,
  catalogus: 20,
}

export const SEARCH_CATEGORIES_ALL_RESULTS_AND_HR = {
  ...SEARCH_CATEGORIES_ALL_RESULTS,
  vestigingen: 6,
  maatschappelijkeactiviteit: 6,
}

export const getDetailPageData = (suggestion: {
  type: DataType
  subType: DataSubtype
  id: string
}): DataIdentifier => {
  return {
    type: suggestion.type,
    subtype: suggestion.subType,
    id: suggestion.id,
  }
}

export const fetchSuggestionsFromSearchApi = async (query: string, signal: AbortSignal) => {
  const hasScope = getScopes().includes(AuthScope.HrR)
  const body = {
    q: query,
    categories: hasScope ? SEARCH_CATEGORIES_SUGGEST_AND_HR : SEARCH_CATEGORIES_SUGGEST,
  }
  return fetchProxy(`${SEARCH_API_URL}`, {
    signal,
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export const fetchResultsFromSearchApi = async (
  query: string,
  category?: string,
  page?: string,
) => {
  const hasScope = getScopes().includes(AuthScope.HrR)
  const allCat = hasScope ? SEARCH_CATEGORIES_ALL_RESULTS_AND_HR : SEARCH_CATEGORIES_ALL_RESULTS
  const categories: { [key: string]: number } = category ? { [category]: 100 } : allCat

  const queryContent = {
    q: query,
    categories,
  }

  const body = page ? { ...queryContent, page } : queryContent
  return fetchProxy<{
    result: Array<{
      totalResults: number
      label: string
      content: DataResult[]
      type: string
    }>
    pageInfo: PageInfo
  }>(`${SEARCH_API_URL}`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export const getSearchResultPath = (location: DataResult) => {
  if (location.subType === DataSubtype.Catalog) {
    return toCatalogDetail(location.id)
  }

  if (location.subType === DataSubtype.MapLayer) {
    return location.uri!
  }

  return toDataDetail(
    {
      id: location.id,
      subtype: location.subType,
      type: location.type,
    },
    true,
  )
}
